import { useMedia } from "react-use";

/** Panda CSSのブレークポイント`sm`をフックとして利用する。 */
export function useSm() {
  return useMedia("(min-width: 640px)");
}

/** Panda CSSのブレークポイント`smDown`をフックとして利用する。 */
export function useSmDown() {
  return useMedia("(max-width: 639px)");
}
